import { Component } from 'react';
import { withRouter, Route } from 'react-router-dom';
import { compose } from 'redux';
import ContextualEmbedDecorator from 'automation-ui-canvas/containers/ContextualEmbedDecorator';
import FlowCanvasOptimizeDecorator from 'automation-ui-canvas/containers/FlowCanvasOptimizeDecorator';
import FlowCanvasBase from 'automation-ui-canvas/containers/FlowCanvasBase';
import FlowCanvasDataSourceEditDecorator from 'automation-ui-canvas/containers/FlowCanvasDataSourceEditDecorator';
import FlowCanvasEmbedPreviewDecorator from 'automation-ui-canvas/containers/FlowCanvasEmbedPreviewDecorator';
import FlowCanvasFullDecorator from 'automation-ui-canvas/containers/FlowCanvasFullDecorator';
import FlowCanvasGoToEditDecorator from 'automation-ui-canvas/containers/FlowCanvasGoToEditDecorator';
import FlowCanvasMoveActionDecorator from 'automation-ui-canvas/containers/FlowCanvasMoveActionDecorator';
import FlowCanvasActionSetDecorator from 'automation-ui-canvas/containers/FlowCanvasActionSetDecorator';
import FlowCanvasAiAssistantReviewDecorator from 'automation-ui-canvas/containers/FlowCanvasAiAssistantReviewDecorator';
import FlowCanvasRevisionPreviewDecorator from 'automation-ui-canvas/containers/FlowCanvasRevisionPreviewDecorator';
import actionFeaturesTranslations from 'i2l?query=sporks!automation-ui-canvas/lang/action-features/en.lyaml';
import LazyLangLoaderDecorator from 'automation-ui-i18n/LazyLangLoaderDecorator';
import DataSourcesProviderWrapper from 'automation-ui-canvas/containers/DataSourcesProviderWrapper';
import { connect } from 'react-redux';
import { getIsEmbedded } from 'automation-ui-canvas/selectors/embedSelectors';
import FlowConfigsContainerAsync from 'automation-ui-canvas/containers/FlowConfigsContainerAsync';
import Routes from 'automation-ui-canvas/constants/Routes';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import FlowCanvasEnrollmentConversionDecorator from 'automation-ui-canvas/containers/FlowCanvasEnrollmentConversionDecorator';
import FlowCanvasSelectedEnrollmentDecorator from 'automation-ui-canvas/containers/FlowCanvasSelectedEnrollmentDecorator';
import FlowCanvasEnrollmentListDecorator from 'automation-ui-canvas/containers/FlowCanvasEnrollmentListDecorator';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FULL_CANVAS = 'fullCanvas';
const GO_TO_EDIT_CANVAS = 'goToEditCanvas';
const DATA_SOURCE_EDIT_CANVAS = 'dataSourceEditCanvas';
const MOVE_ACTION_CANVAS = 'moveActionCanvas';
const REVISION_PREVIEW_CANVAS = 'revisionPreviewCanvas';
const CONTEXTUAL_AUTOMATION = 'contextualAutomation';
const PREVIEW_CANVAS = 'templateAndFlowPreviewCanvas';
const OPTIMIZE_CANVAS = 'optimizeCanvas';
const ACTION_SET = 'actionSet';
const AI_ASSISTANT_REVIEW_CANVAS = 'aiAssistantReview';
const ENROLLMENT_CONVERSION_CANVAS = 'enrollmentConversionCanvas';
const ENROLLMENT_HISTORY_CANVAS = 'enrollmentHistoryCanvas';
const ENROLLMENT_HISTORY_LIST_CANVAS = 'enrollmentHistoryListCanvas';
const FLOW_VIEW = 'flowView';
class FlowCanvasContainer extends Component {
  constructor(props) {
    super(props);
    this.getFlowCanvasImplementation = (mode, centerOnMount) => {
      switch (mode) {
        case FULL_CANVAS:
          return FlowCanvasFullDecorator(FlowCanvasBase, centerOnMount);
        case ACTION_SET:
          return FlowCanvasActionSetDecorator(FlowCanvasBase, centerOnMount);
        case ENROLLMENT_HISTORY_CANVAS:
          {
            return FlowCanvasSelectedEnrollmentDecorator(FlowCanvasBase, centerOnMount);
          }
        case ENROLLMENT_HISTORY_LIST_CANVAS:
          {
            return FlowCanvasEnrollmentListDecorator(FlowCanvasBase, centerOnMount);
          }
        case GO_TO_EDIT_CANVAS:
          return FlowCanvasGoToEditDecorator(FlowCanvasBase, centerOnMount);
        case DATA_SOURCE_EDIT_CANVAS:
          return FlowCanvasDataSourceEditDecorator(FlowCanvasBase, centerOnMount);
        case MOVE_ACTION_CANVAS:
          return FlowCanvasMoveActionDecorator(FlowCanvasBase, centerOnMount);
        case REVISION_PREVIEW_CANVAS:
          return FlowCanvasRevisionPreviewDecorator(FlowCanvasBase, centerOnMount);
        case CONTEXTUAL_AUTOMATION:
          return ContextualEmbedDecorator(FlowCanvasBase, centerOnMount);
        case PREVIEW_CANVAS:
          return FlowCanvasEmbedPreviewDecorator(FlowCanvasBase);
        case OPTIMIZE_CANVAS:
          return FlowCanvasOptimizeDecorator(FlowCanvasBase, centerOnMount);
        case AI_ASSISTANT_REVIEW_CANVAS:
          return FlowCanvasAiAssistantReviewDecorator(FlowCanvasBase);
        case ENROLLMENT_CONVERSION_CANVAS:
          {
            return FlowCanvasEnrollmentConversionDecorator(FlowCanvasBase, centerOnMount);
          }
        default:
          return FlowCanvasBase;
      }
    };
    this.setMode = mode => {
      this.FlowCanvasImplementation = this.getFlowCanvasImplementation(mode, false);
      this.forceUpdate();
    };
    this.FlowCanvasImplementation = this.getFlowCanvasImplementation(props.mode);
  }
  componentDidUpdate({
    mode: prevMode
  }) {
    const {
      mode: currentMode
    } = this.props;
    if (prevMode !== currentMode) {
      this.setMode(currentMode);
    }
  }
  render() {
    const {
      areLangStringsLoading,
      overrideParams,
      overrideParsedQuery,
      isEmbedded
    } = this.props;
    if (areLangStringsLoading) {
      return null;
    }

    // flowId is only present in the case of being called from an embedded use case.
    const {
      flowId
    } = overrideParams || {};
    // sourceAppId is only present in the case of being called from an embedded use case.
    const {
      sourceAppId
    } = overrideParsedQuery || {};
    const FlowCanvasImplementationToUse = this.FlowCanvasImplementation;
    const content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FlowCanvasImplementationToUse, Object.assign({}, this.props)), !isEmbedded && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Route, {
          path: Routes.PLATFORM_UNENROLLMENT,
          component: FlowConfigsContainerAsync
        })
      })]
    });
    if (flowId) {
      /**
       * Dev Note: DataSourcesProvider is only provided at this level if displayed in an embed.
       * Otherwise the DataSourcesProvider comes from FlowContainer.
       */
      return /*#__PURE__*/_jsx(DataSourcesProviderWrapper, {
        flowId: flowId,
        sourceAppId: sourceAppId,
        children: content
      });
    } else {
      return content;
    }
  }
}
export const WEBPACK_3_FORCE_MODULE_IMPORT = 1;
export default compose(wireAuthConsumer, withRouter, LazyLangLoaderDecorator([actionFeaturesTranslations]), connect(state => ({
  isEmbedded: getIsEmbedded(state)
})))(FlowCanvasContainer);